export default __webpack_public_path__ + "static/CentraNo2-MediumItalic-71a8f789458933ef06b840f9acf236c2.woff2";